import { Col, Row } from "antd";
import React from "react";
import DashboardCard from "../../Components/Card/Dashboard";
import NoticeCard from "../../Components/Card/Notice";
import Container from "../../Components/Container";
import FlatList from "../../Components/FlatList";
import Loading from "../../Components/Loading";
import Table from "../../Components/Table";
import { renderPrice } from "../../Utils/functions";
import { Calender, NoteFavorite, WalletMoney } from "../../Utils/icons";
import { useDashboard } from "./Hooks";
import "./style.scss";
const Dashboard = () => {
  const { state, loading, user, send, loadingBtn } = useDashboard();
  if (loading) {
    return (
      <>
        <Row gutter={20}>
          <Col lg={8} span={24}>
            <Loading />
          </Col>{" "}
          <Col lg={8} span={24}>
            {" "}
            <Loading />
          </Col>{" "}
          <Col lg={8} span={24}>
            {" "}
            <Loading />
          </Col>
        </Row>
        <Row gutter={20}>
          <Col lg={16} span={24}>
            {" "}
            <Loading />
          </Col>
          <Col lg={8} span={24}>
            {" "}
            <Loading />
          </Col>
        </Row>
      </>
    );
  }
  return (
    <>
      <Row justify={"space-between"} gutter={20} className="mb-24 ">
        <Col lg={8} span={24}>
          <DashboardCard
            title={"کل فاکتور‌های پرداخت شده"}
            subTitle={renderPrice(state.total_payed_invoices, "/")}
            icon={() => <WalletMoney />}
          />
        </Col>
        <Col lg={8} span={24}>
          <DashboardCard
            title={"تعداد کل فاکتورهای ایجاد شده"}
            subTitle={`${state.total.total} عدد`}
            icon={() => <NoteFavorite />}
          />
        </Col>
        <Col lg={8} span={24}>
          <DashboardCard
            title={"روز باقی مانده از اشتراک ویژه"}
            subTitle={`${state?.premium_subscription_left} روز`}
            icon={() => <Calender />}
            tamdid={state?.premium_subscription_left <= 7}
            onClick={() => send()}
            loading={loadingBtn}
          />
        </Col>
      </Row>
      <Row gutter={20}>
        <Col lg={16} span={24} className="mb-sm-25">
          <Container title="آخرین فاکتور‌های ایجاد شده" dashboard>
            <Table data={state?.total?.data} />
          </Container>
        </Col>
        <Col lg={8} span={24}>
          <Container title="اطلاعیه‌ها" dashboard>
            <FlatList
              renderItem={(item, key) => <NoticeCard data={item} key={key} />}
              data={state.notifications}
              renderEmpty={() => {
                return (
                  <div className="empty-box">
                    <div className="image-empty">
                      <img src={require("../../Assets/images/empty.png")} />
                    </div>
                    <div className="text-empty">
                      <p className="text-center text-sub fs-11 lh-19 fw-600">
                        در حال حاضر اطلاعیه وجود ندارد
                      </p>
                    </div>
                  </div>
                );
              }}
            />
          </Container>
        </Col>
      </Row>
    </>
  );
};

export default Dashboard;
